import script from "./AppAlert.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppAlert.vue?vue&type=script&lang=ts&setup=true"

import "./AppAlert.vue?vue&type=style&index=0&id=ccccc350&lang=scss"

const __exports__ = script;

export default __exports__